import script from "./ArtistCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistCard.vue?vue&type=script&setup=true&lang=js"

import "./ArtistCard.vue?vue&type=style&index=0&id=a5000400&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5000400"]])

export default __exports__